import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { HoverLabelTheme } from './types';
import { ThemeProps } from './types';

const styles = (lightOrDarkVersion: HoverLabelTheme) => {
  const darkColor = theme.colors.neutral90;
  const resolvedBackground = lightOrDarkVersion === 'dark' ? darkColor : theme.colors.white;
  const resolvedColor = lightOrDarkVersion === 'dark' ? theme.colors.white : darkColor;

  return css`
    background: ${resolvedBackground};
    box-shadow: ${theme.shadows.floating};
    font-weight: ${theme.font.weight.bold};
    color: ${resolvedColor};
    max-width: 270px;
    padding: ${theme.spacing(1)};
  `;
};

export const HoverLabelStyles = {
  hoverLabel: (props: ThemeProps) => styles(props.theme),
};
